export default __webpack_public_path__ + "media/components/AudienceEdit/blue_check-3d916db9623fca4293bcd804c3cd7e87.png";